export default [
    {
        path: "/asignacion-perfiles",
        name: "asignacion-perfiles",
        component: () =>
            import(/* webpackChunkName: "estructuraStepper" */ "./index.vue"),
    },
    {
        path: "/asignacion-perfiles/asignar/:id",
        name: "asignacion-perfiles-asignar",
        component: () =>
            import(
                /* webpackChunkName: "nomina" */ "./formAsignacion.vue"
            ),
    },
    {
        path: "/asignacion-perfiles-jefatura",
        name: "asignacion-perfiles-jefatura",
        component: () =>
            import(/* webpackChunkName: "estructuraStepper" */ "./indexJefatura.vue"),
    },
    {
        path: "/asignacion-perfiles-jefatura/asignar/:id",
        name: "asignacion-perfiles-jefatura-asignar",
        component: () =>
            import(
                /* webpackChunkName: "nomina" */ "./editarPerfilJefatura.vue"
            ),
    },
];